import { render, staticRenderFns } from "./addFollow.vue?vue&type=template&id=65f57725&scoped=true&"
import script from "./addFollow.vue?vue&type=script&lang=js&"
export * from "./addFollow.vue?vue&type=script&lang=js&"
import style0 from "./addFollow.vue?vue&type=style&index=0&id=65f57725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f57725",
  null
  
)

export default component.exports